<div class="wrapper" *ngIf="state === 'inProgress'">
  <h1>{{storyService.strname}}</h1>
  <div class="foo">

    <div id="carouselExampleIndicators" class="carousel slide" data-pause="">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <section id="section">

            <div class="card1">

              <!-- pages indicator -->
              <div *ngIf="(storyLength != undefined && storyLength != null && storyLength != 0)" class="page-indicator"><span>{{storyService.currentPageNumber}}<hr color="white" style="margin: 0;" />{{storyLength}}</span></div>

              <!-- spinner meanwhile we start playing -->
              <div class="play-audio-spinner">
                <mat-spinner *ngIf="btnPlayClicked" diameter="40"></mat-spinner>
              </div>

              <!-- story page image -->
              <div  class="story-image" id="storyImageContainer">
                <!-- <img src="{{pageImage}}" id="storyImage" alt="image"> -->
              </div>

              <!-- story with audio -->
              <div class="story">
                <!-- list of words -->
                <p id="story-words-page-1" #div_1>
                  <span class="word-span-p1" *ngFor="let wrd of currentPageWords; let i = index">
                    <span class="word-span-p2" *ngIf="wrd!=='<br/>'; else newLine" id="page1_{{i+1}}">
                      <span class="word-span" *ngIf="wrd!=='<br/>'; else newLine">{{wrd}}</span>
                    </span>
                  </span>
                  <ng-template #newLine><br/><br class="paragraph-break"/></ng-template>
                </p>
                <div #ref class="audios-0 audio">
                  <audio id="audio-2" class="sub-audio-0" preload="auto" #pageAudio>
                    <source id="pageAudio-1" src="" type="audio/mpeg">
                  </audio>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- arrow prev -->
      <a *ngIf="showPrevBtn" class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev" id="prev-page-btn" (click)="changeStoryPageManually('prev')">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">{{ 'story.text1' | translate }}</span>
      </a>

      <!-- arrow next -->
      <a *ngIf="showNextBtn" class="carousel-control-next" href="#carouselExampleIndicators" role="button" #next data-slide="next" id="next-page-btn" (click)="changeStoryPageManually('next')">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">{{ 'story.text2' | translate }}</span>
      </a>
    </div>

    <!-- buttons play/stop/back -->
    <div class="button-group vertical mt-4">

      <button mat-raised-button color="primary" [hidden]="storyAudioPlayMethod == 2" [disabled]="!play || pauseAudio || waitForAudioLoad" (click)="play=false; toggleAudio('true');">
        {{ 'story.text3' | translate }} <mat-icon>play_arrow</mat-icon>
      </button>

      <button mat-raised-button color="primary" [hidden]="storyAudioPlayMethod == 2" [disabled]="play || waitForAudioLoad" (click)="play=true; toggleAudio('false');">
        {{ 'story.text4' | translate }} <mat-icon>stop</mat-icon>
      </button>

      <button mat-raised-button color="primary" (click)="restartStoryPage()">{{ 'story.text5' | translate }} <mat-icon>play_arrow</mat-icon><mat-icon>keyboard_return</mat-icon></button>

      <button mat-raised-button color="primary" (click)="backToHome2()"> <mat-icon>home</mat-icon> {{ 'story.text6' | translate }}</button>

      <mat-spinner  *ngIf="(pauseAudio && !playAudio) || waitForAudioLoad"  [hidden]="storyAudioPlayMethod == 2" diameter="40"></mat-spinner>

    </div>

  </div>
</div>

<app-story-end [isAssignmentMode]="isAssignmentMode" *ngIf="state === 'DONE'"></app-story-end>
<!-- <script src="https://code.responsivevoice.org/responsivevoice.js?key=e5dGgiAW"></script> -->
